const APP = require('APP')
const _ = require('underscore')
const trans = require('trans')
const Backbone = require('backbone')

const { get } = require('ajax')
const router = require('router')
const SimpleDialog = require('UI/SimpleDialog')
const Infobox = require('UI/Infobox')
const { gaHelper } = require('../../../app/containers/AnalyticsGoogleTag/gaHelper')

const UserModel = Backbone.Model.extend({
  config: {},

  initialize() {
    this.loadConfig()
  },

  loadConfig() {
    if (APP.getConfigString) {
      APP.getConfigString(this.configFirstLoaded.bind(this))
    } else if (APP.user) {
      this.sourceConfig = { user: APP.user }
      this.config = _.merge(this.config || {}, APP.user)
      this.trigger('update', this.sourceConfig)
    }
  },

  configFirstLoaded(configStr, time) {
    gaHelper.sendGATimeEvent('Config load', true, time)

    const sourceConfig = (this.sourceConfig = JSON.parse(configStr).data)
    if (sourceConfig && sourceConfig.user) {
      APP.defaultCategorySlug = sourceConfig.defaultCategory
      this.initFlashMessages(sourceConfig)
      this.config = _.merge(this.config || {}, sourceConfig.user)
      this.trigger('update', sourceConfig)
      this.off('update')
    } else {
      throw new Error('user "loadConfig" config error')
    }
  },

  login() {
    router.pathRedirect('fos_user_security_login')
  },

  onLoadConfig(f) {
    if (this.sourceConfig) {
      f(this.sourceConfig)
    } else if (_.isFunction(f)) {
      this.bind('update', f)
    }
  },

  initFlashMessages(data) {
    if (data.flashMessages && data.flashMessages.length) {
      _.forEach(data.flashMessages, (msg) => {
        Infobox(trans(msg.text), {
          type: msg.type,
          margin: false,
        })
      })
    }
  },

  sync() {
    if (!this.config.isLogged) {
      // user not logged so no need to get config loaded
      return
    }
    this.configUrl = this.configUrl || router.path('multilotto_user_config')
    const that = this
    get(this.configUrl, {
      always() {
        that.syncTimeout()
      },
      done(data) {
        that.config = _.merge(that.config || {}, data.data.user)

        if (!that.config.isLogged) {
          SimpleDialog.dialog({
            title: trans('session_expired'),
            content: trans('Session expired description'),
            buttons: {
              login: {
                label: 'Login',
                callback() {
                  router.pathRedirect('fos_user_security_login')
                },
              },
            },
            close() {
              router.refresh()
            },
          })

          return
        }

        that.trigger('sync', data.data)
      },
    })
  },

  syncTimeout() {
    if (!this.syncTimeoutTime) {
      this.syncTimeoutTime = APP.userSyncTimeout || 90000
      delete APP.userSyncTimeout
    }

    clearTimeout(this.timeoutId)
    this.timeoutId = _.delay(this.sync.bind(this), this.syncTimeoutTime)
  },
})

module.exports = new UserModel()
